import { useParams, Navigate } from "react-router-dom";
import { PillarPage } from "../components/medskin/PillarPage";
import { PILLARS } from "../lib/pillar-data";

export default function PillarRoute() {
  const { slug } = useParams();
  const data = PILLARS[slug];
  if (!data) return <Navigate to="/" replace />;
  return <PillarPage data={data} />;
}
